import { MatchType, PlayerGrouping } from '@nova/types';

import { assetLobbyThumbOutpostRun } from './asset-bundle-names';

export const matchConfigOrLiteral = [
  {
    type: MatchType.outpostRuns,
    id: 'level-tutorial',
    mapAssetName: 'level-tutorial',
    name: 'loc:::match_config_tutorial',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::match_config_tutorial',
      dataKey: assetLobbyThumbOutpostRun
    }
  },
  {
    type: MatchType.outpostRuns,
    id: 'level-1',
    mapAssetName: 'level-1',
    name: 'loc:::match_config_outpost_run_1_name',
    unlockedByMatchConfigId: 'level-tutorial',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::match_config_or_level_1_name',
      dataKey: assetLobbyThumbOutpostRun,
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  },
  {
    type: MatchType.outpostRuns,
    id: 'level-2',
    mapAssetName: 'level-2',
    name: 'loc:::match_config_outpost_run_2_name',
    unlockedByMatchConfigId: 'level-1',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::match_config_or_level_2_name',
      dataKey: assetLobbyThumbOutpostRun,
      unlockTooltip: 'loc:::completeLevel1ToUnlock'
    }
  },
  {
    type: MatchType.outpostRuns,
    id: 'level-3',
    mapAssetName: 'level-3',
    name: 'loc:::match_config_outpost_run_3_name',
    unlockedByMatchConfigId: 'level-2',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::match_config_or_level_3_name',
      dataKey: assetLobbyThumbOutpostRun,
      unlockTooltip: 'loc:::completeLevel2ToUnlock'
    }
  }
] as const;
